import React from "react";
import TaskCard from "./TaskCard";
import { DAYS, CATEGORIES } from "./mockTasks";

const COL_WIDTH  = 220;
const ROW_LABEL  = 130;

function fmtDate(weekStart, dayIndex) {
  if (!weekStart) return "";
  const d = new Date(weekStart);
  d.setDate(d.getDate() + dayIndex);
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

const SchedulerGrid = ({ tasks, weekStart, isEmployee }) => {
  // cellMap: "CATEGORY__Day" → task (first match wins)
  const cellMap = {};
  tasks.forEach((t) => {
    const key = `${t.category}__${t.day}`;
    if (!cellMap[key]) cellMap[key] = t;
  });

  return (
    <div
      style={{
        overflowX: "auto",
        borderRadius: 12,
        border: "1px solid #e2e8f0",
        background: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        marginBottom: 20,
      }}
    >
      <table
        style={{
          borderCollapse: "collapse",
          minWidth: ROW_LABEL + COL_WIDTH * DAYS.length,
          width: "100%",
          tableLayout: "fixed",
        }}
      >
        {/* ── Column widths ── */}
        <colgroup>
          <col style={{ width: ROW_LABEL }} />
          {DAYS.map((d) => (
            <col key={d} style={{ width: COL_WIDTH }} />
          ))}
        </colgroup>

        {/* ── Header row ── */}
        <thead>
          <tr>
            <th
              style={{
                background: "#f8fafc",
                borderBottom: "2px solid #e2e8f0",
                borderRight: "1px solid #e2e8f0",
                padding: "12px 16px",
                textAlign: "left",
                fontSize: 11,
                fontWeight: 700,
                color: "#94a3b8",
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                position: "sticky",
                left: 0,
                zIndex: 3,
              }}
            >
              
            </th>
            {DAYS.map((day, i) => (
              <th
                key={day}
                style={{
                  background: "#f8fafc",
                  borderBottom: "2px solid #e2e8f0",
                  borderRight: "1px solid #e2e8f0",
                  padding: "12px 16px",
                  textAlign: "left",
                }}
              >
                <div style={{ fontSize: 13, fontWeight: 700, color: "#334155" }}>{day}</div>
                <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>
                  {fmtDate(weekStart, i)}
                </div>
              </th>
            ))}
          </tr>
        </thead>

        {/* ── Data rows ── */}
        <tbody>
          {CATEGORIES.map((cat) => {
            // Build cell list with colspan support
            const cells = [];
            let skipCount = 0;

            DAYS.forEach((day, dayIdx) => {
              if (skipCount > 0) {
                skipCount--;
                return; // this column is absorbed by a previous colspan
              }
              const task = cellMap[`${cat.key}__${day}`] || null;
              const span = task?.daySpan || 1;
              if (span > 1) skipCount = span - 1;
              cells.push({ day, dayIdx, task, span });
            });

            return (
              <tr key={cat.key}>
                {/* ── Row label ── */}
                <td
                  style={{
                    background: "#f8fafc",
                    borderBottom: "1px solid #e2e8f0",
                    borderRight: "2px solid #e2e8f0",
                    padding: "14px 16px",
                    verticalAlign: "middle",
                    position: "sticky",
                    left: 0,
                    zIndex: 2,
                  }}
                >
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 800,
                      color: "#4f46e5",
                      background: "#eef2ff",
                      borderRadius: 6,
                      padding: "3px 9px",
                      display: "inline-block",
                      marginBottom: 4,
                      letterSpacing: "0.04em",
                    }}
                  >
                    {cat.key}
                  </span>
                  <div
                    style={{
                      fontSize: 10,
                      color: "#64748b",
                      lineHeight: 1.3,
                      fontWeight: 500,
                    }}
                  >
                    
                  </div>
                </td>

                {/* ── Day cells ── */}
                {cells.map(({ day, task, span }) => (
                  <td
                    key={day}
                    colSpan={span}
                    style={{
                      borderBottom: "1px solid #e2e8f0",
                      borderRight: "1px solid #e2e8f0",
                      padding: 0,
                      verticalAlign: "top",
                    }}
                  >
                    {task ? (
                      <TaskCard task={task} isEmployee={isEmployee} />
                    ) : (
                      <div style={{ height: 100, background: "#fff" }} />
                    )}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SchedulerGrid;